import { gql } from "@apollo/client";

import { EVENT_TEMPLATE_WITH_RELATIONS_FRAGMENT } from "./fragments/eventTemplateWithRelations";

export const GET_EVENT_TEMPLATES = gql`
  ${EVENT_TEMPLATE_WITH_RELATIONS_FRAGMENT}
  query GetEventTemplates(
    $take: Int
    $skip: Int
    $filters: EventFilterInput
    $orderBy: [EventOrderByInput!]
    $recurringSettingsInclude: Boolean = false
    $venueInclude: Boolean = false
    $imageInclude: Boolean = false
    $seatMapInclude: Boolean = false
    $ticketPoolsInclude: Boolean = false
    $ticketPoolsSkip: Int
    $ticketPoolsTake: Int
    $ticketPoolsFilters: TicketPoolFilterInput
    $ticketPoolsOrderBy: [TicketPoolOrderByInput!]
    $presalePasswordsInclude: Boolean = false
    $presalePasswordsSkip: Int
    $presalePasswordsTake: Int
    $presalePasswordsFilters: PresalePasswordFilterInput
    $presalePasswordsOrderBy: [PresalePasswordOrderByInput!]
    $discountCodesInclude: Boolean = false
    $discountCodesSkip: Int
    $discountCodesTake: Int
    $discountCodesFilters: DiscountCodeFilterInput
    $discountCodesOrderBy: [DiscountCodeOrderByInput!]
  ) {
    eventTemplates(
      take: $take
      skip: $skip
      filters: $filters
      orderBy: $orderBy
    ) {
      count
      nodes {
        ...EventTemplateWithRelations
      }
    }
  }
`;

export const GET_EVENT_TEMPLATE = gql`
  ${EVENT_TEMPLATE_WITH_RELATIONS_FRAGMENT}
  query GetEventTemplate(
    $id: Int!
    $recurringSettingsInclude: Boolean = false
    $venueInclude: Boolean = false
    $imageInclude: Boolean = false
    $seatMapInclude: Boolean = false
    $ticketPoolsInclude: Boolean = false
    $ticketPoolsSkip: Int
    $ticketPoolsTake: Int
    $ticketPoolsFilters: TicketPoolFilterInput
    $ticketPoolsOrderBy: [TicketPoolOrderByInput!]
    $presalePasswordsInclude: Boolean = false
    $presalePasswordsSkip: Int
    $presalePasswordsTake: Int
    $presalePasswordsFilters: PresalePasswordFilterInput
    $presalePasswordsOrderBy: [PresalePasswordOrderByInput!]
    $discountCodesInclude: Boolean = false
    $discountCodesSkip: Int
    $discountCodesTake: Int
    $discountCodesFilters: DiscountCodeFilterInput
    $discountCodesOrderBy: [DiscountCodeOrderByInput!]
  ) {
    eventTemplate(id: $id) {
      ...EventTemplateWithRelations
    }
  }
`;
